if (!customElements.get('accordion-with-image')) {
  class AccordionWithImage extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('.accordion-with-image__item'));
      this.images = Array.from(this.querySelectorAll('.accordion-with-image__img'));

      this.items.forEach((item) => {
        const trigger = item.querySelector('.accordion-with-image__trigger');
        trigger.addEventListener('click', () => this.open(item));
      });
    }

    open(item) {
      if (item.classList.contains('is-open')) return;

      this.items.forEach((other) => {
        const isTarget = other === item;
        other.classList.toggle('is-open', isTarget);
        other.querySelector('.accordion-with-image__trigger').setAttribute('aria-expanded', isTarget);
      });

      const index = item.dataset.index;
      this.images.forEach((img) => {
        img.classList.toggle('is-active', img.dataset.index === index);
      });
    }
  }

  customElements.define('accordion-with-image', AccordionWithImage);
}
